/**
 * NotCheckedIn（未出社画面）
 * 詳細設計書 §4.1 SC-L01-A に対応。
 *
 * Props:
 *   onCheckIn {function} 出社登録完了時コールバック（assignmentData を渡す）
 */
import { useState } from 'react';
import { checkIn } from '../api/lifeApi';
import NoSeatModal from './NoSeatModal';

// 空席なしはAPIがエラーコードを持たず文言のみで返すため、
// seat_assignment_service.py の文言の一部で判定する
const NO_SEAT_MESSAGE = '空席がありません';

function NotCheckedIn({ onCheckIn }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isNoSeatOpen, setIsNoSeatOpen] = useState(false);

  const handleCheckIn = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await checkIn();
      onCheckIn(res?.data ?? null);
    } catch (err) {
      // 既出社の場合も出社済み画面へ遷移
      if (err.status === 400 && err.message?.includes('ALREADY_CHECKED_IN')) {
        onCheckIn(null);
      } else {
        const message = err.message || '出社登録に失敗しました。';
        setError(message);
        setIsNoSeatOpen(message.includes(NO_SEAT_MESSAGE));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="life-not-checked-in">
      {/* アイコン円 */}
      <div className="life-icon-circle life-icon-circle--sm" aria-hidden="true">
        <span style={{ fontSize: 28, color: 'var(--life-primary)' }}>📍</span>
      </div>

      {/* サブタイトル */}
      <p className="life-subtitle">
        Location Information<br />for Employee
      </p>

      {/* 説明カード */}
      <div className="life-card" style={{ textAlign: 'center' }}>
        <p style={{ fontWeight: 600, margin: '0 0 6px' }}>
          本日はまだ出社登録されていません
        </p>
        <p style={{ fontSize: 13, color: 'var(--life-muted-foreground)', margin: 0 }}>
          出社登録を行うと、座席が自動で割り当てられます
        </p>
      </div>

      {/* エラー表示 */}
      {error && <div className="life-error" role="alert">{error}</div>}

      {/* 出社ボタン */}
      <button
        className="life-btn life-btn--primary"
        onClick={handleCheckIn}
        disabled={loading}
        style={{ width: '100%' }}
      >
        {loading ? (
          <>
            <span className="life-spinner" aria-hidden="true" />
            処理中...
          </>
        ) : (
          '🏢 出社する'
        )}
      </button>

      {/* 注釈 */}
      <p className="life-note">※ 出社登録は1日1回のみ可能です</p>

      <NoSeatModal isOpen={isNoSeatOpen} onClose={() => setIsNoSeatOpen(false)} />
    </div>
  );
}

export default NotCheckedIn;
